customElements.get("read-more-text") || customElements.define("read-more-text", class extends HTMLElement {
  #t;
  #e;
  #s=!1;
  constructor() {
    super(), this.#t = this.querySelector("[data-read-more-text]"), this.#e = this.querySelector("[data-read-more-button]");
  }
  connectedCallback() {
    this.#t && this.#e && (this.#e.addEventListener("click", this.#i), requestAnimationFrame(() => this.#n()), 
    window.addEventListener("resize", this.#o));
  }
  disconnectedCallback() {
    this.#e?.removeEventListener("click", this.#i), window.removeEventListener("resize", this.#o);
  }
  #n() {
    if (this.#s) return;
    const t = this.#t.scrollHeight > this.#t.clientHeight + 1;
    this.classList.toggle("has-overflow", t);
  }
  #o=() => {
    this.#s || this.#n();
  };
  #i=() => {
    this.#s = !this.#s, this.#t.classList.toggle("line-clamp-3", !this.#s), this.classList.toggle("is-expanded", this.#s), 
    this.#e.textContent = this.#s ? this.#e.dataset.labelLess : this.#e.dataset.labelMore;
  };
});